import { useSharedValueStoreContext } from './context';
import { useMemo } from 'react';
export function useSharedService(service) {
    var context = useSharedValueStoreContext();
    return useMemo(function () { return context.service(service); }, [context]);
}
//# sourceMappingURL=use-shared-service.js.map